module.exports = __webpack_public_path__ + "static/media/LostCards.2ff6f6e0.svg";